import React from "react"
import {withFormik} from "formik";
import * as yup from "yup"
import {phoneRegExp} from "../../services/regex";
import httpClient from "../../services/httpClient";
import {authApi} from "../../constans/apiUrls";
import {IAuthMobileData} from "../../contracts/data/auth";
import InnerAuthMobileForm from "../../components/FormTemplates/auth/InnerAuthMobileForm";

const authMobileFormValidationSchema = yup.object().shape({
    mobile: yup.string().required("شماره موبایل الزامی میباشد").length(11, "شماره موبایل 11 رقم میباشد").matches(phoneRegExp, "شماره موبایل نادرست میباشد")
})

interface IAuthMobileFormProps{
    saveMobile: any
}

const AuthMobileForm = withFormik<IAuthMobileFormProps, IAuthMobileData>({
    mapPropsToValues: props => ({
        mobile: '',
    }),
    validationSchema:(props: any) => authMobileFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        await httpClient().post(authApi.mobile, {mobile: values.mobile})
            .then(res => {
                if(res.status === 200){
                    formikBag.props.saveMobile(values.mobile)
                }
            })
            .catch(err => {
                formikBag.setFieldError('mobile',err.response?.status === 400 || err.response?.status === 404 ? err?.response?.data?.message : "شماره موبایل نادرست میباشد")
            })
    },
    displayName: 'AuthMobile'
})(InnerAuthMobileForm)

export default AuthMobileForm